import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import "../css/main.css";

const About = () => {

    const cardStyle = {
        border: '1px solid #dee2e6',
        borderRadius: '8px',
        padding: '2rem',
        boxShadow: '0 0 10px silver',
        backgroundColor: 'black',
        color: 'whitesmoke'
    };
    const mapStyle = {
        width: '100%',
        height: '300px',
        border: 0,
        marginTop: '1rem'
    };

    return (
        <Container fluid style={{ padding: '3rem 1rem' }}>
            <h1 className="text-center mb-4" style={{ fontSize: '2.5rem', fontWeight: 'bold', textDecoration: 'underline' }}>
                Contact Us
            </h1>
            <h4 className="text-center mb-5" style={{ maxWidth: '800px', margin: '0 auto', fontWeight: 'normal' }}>
                We are currently situated in South Africa and the United Kingdom.
                <br />
                Feel free to reach out to either of our offices.
            </h4>

            <Container>
                <Row className="gy-5">
                    {/* South Africa Office */}
                    <Col md={6}>
                        <div style={cardStyle}>
                            <h3 style={{ marginBottom: '1rem', color: 'whitesmoke' }}>South Africa</h3>
                            <p><strong>Address:</strong> 49 Alexander Road, Westmead, Pinetown, Kwazulu-Natal, South Africa, 3608</p>
                            <p><strong>Tel:</strong> +27 31 780 2560</p>
                            <p><strong>Email:</strong> <a href="mailto:sales@mhe.co.za">sales@mhe.co.za</a></p>
                            <iframe
                                title="MHE South Africa Location"
                                style={mapStyle}
                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1041.7150882390254!2d30.83542771808612!3d-29.821198313456204!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1ef6fe93b4bf4001%3A0xfd7d416f1cf1f608!2s49+Alexander+Rd%2C+Westmead%2C+Pinetown%2C+3608!5e0!3m2!1sen!2sza!4v1566297880331!5m2!1sen!2sza"
                                allowFullScreen
                                loading="lazy"
                            />
                        </div>
                    </Col>

                    {/* United Kingdom Office */}
                    <Col md={6}>
                        <div style={cardStyle}>
                            <h3 style={{ marginBottom: '1rem', color: 'whitesmoke' }}>United Kingdom</h3>
                            <p><strong>Address:</strong> Fairstead House, Erratts Hill, Cowlinge, Newmarket, Suffolk, CB8 9QD</p>
                            <p><strong>Tel:</strong> +44 1440 820381</p>
                            <p><strong>Email:</strong> <a href="mailto:mike@mheuk.co.uk">mike@mheuk.co.uk</a></p>
                            <iframe
                                title="MHE UK Location"
                                style={mapStyle}
                                src="https://maps.google.com/maps?q=52.157000,0.507000&z=15&output=embed"
                                allowFullScreen
                                loading="lazy"
                                referrerPolicy="no-referrer-when-downgrade"
                            />
                        </div>
                    </Col>
                </Row>
            </Container>
        </Container>
    );
};

export default About;
